import QuickLaunch from './quickLaunch'
import ToDo from './toDo'

const state = Object.assign({}, QuickLaunch.state, ToDo.state)
const getters = Object.assign({}, QuickLaunch.getters, ToDo.getters)
const actions = Object.assign({}, QuickLaunch.actions, ToDo.actions)
const mutations = Object.assign({}, QuickLaunch.mutations, ToDo.mutations)

export default {
  state,
  getters,
  mutations,
  actions
}
